import { gql, useMutation } from '@apollo/client';
import { useAuth } from '../auth/useAuth';
import { useLogger } from '@amzn/xb-hooks';
import { REGISTER_LEARNING_ACTIVITY_ERROR } from '../../common/rumMetrics';

export const REGISTER_LEARNING_ACTIVITY = gql`
    mutation registerLearningActivity($userId: ID!, $learningActivityId: ID!) {
        registerLearningActivity(userId: $userId, learningActivityId: $learningActivityId) {
            id
            registrationStatus
        }
    }
`;

export const useRegisterLearningActivity = (learningActivityId: string) => {
    const { log, count } = useLogger();
    const { user } = useAuth();
    return useMutation(REGISTER_LEARNING_ACTIVITY, {
        variables: { userId: user.id, learningActivityId: learningActivityId },
        onError: (error) => {
            log.error('Error registering learning activity', error);
            count(REGISTER_LEARNING_ACTIVITY_ERROR);
        },
    });
};
